import { gql, useQuery } from 'urql';
import { useEffect, useState } from 'react';

export const GetInviteStatusQuery = gql`
  query GetInviteStatus($hash: String!) {
    getInviteStatus(input: { hash: $hash }) {
      ticketHash
      firstName
      lastName
      eventName
      dateStart
      dateEnd
      invitationStatus
      ticketSent
      inviteAcceptionInfo
    }
  }
`;

export enum InvitationStatusEnum {
  PENDING = 'PENDING',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  BLOCKED = 'BLOCKED',
  EXPIRED = 'EXPIRED',
}

export interface InviteStatus {
  ticketHash: string;
  firstName: string | null;
  lastName: string | null;
  eventName: string;
  dateStart: string;
  dateEnd: string;
  invitationStatus: InvitationStatusEnum;
  ticketSent: boolean;
  inviteAcceptionInfo: string;
}

interface GetInviteStatusResponse {
  getInviteStatus: InviteStatus;
}

const useFetchInviteStatus = (hash: string) => {
  const [isPaused, setIsPaused] = useState(false);

  const [result, reexecute] = useQuery<GetInviteStatusResponse>({
    query: GetInviteStatusQuery,
    variables: { hash },
    requestPolicy: 'network-only',
    pause: isPaused,
  });

  const { data, fetching, error } = result;

  useEffect(() => {
    if (error?.networkError) {
      setIsPaused(true);
    }
  }, [error]);

  const refetch = () => {
    setIsPaused(false);
    reexecute({ requestPolicy: 'network-only' });
  };

  return {
    data,
    fetching,
    error,
    refetch,
  };
};

export default useFetchInviteStatus;
